import { gql } from '@apollo/client'

export const GRANTED_WEB_SETTINGS = gql`
  query GrantedWebSettings($name: String, $type: String, $partnerSlug: String) {
    grantedWebSettings(name: $name, type: $type, partnerSlug: $partnerSlug) {
      edges {
        node {
          pk
          id
          name
          type
          settings
          sections {
            pk
            id
            name
            type
            isVisible
            settings
          }
        }
      }
    }
  }
`

export const GRANTED_PACKAGES = gql`
  query GrantedPackages($artworkSlug: String!, $isTicket: Boolean!) {
    allPackages(artworks_Slug: $artworkSlug, isTicket: $isTicket, status: "public") {
      edges {
        node {
          id
          pk
          name
          price
          quantity

          longDescription
          shortDescription

          deliveryNotes

          minSplit
          maxSplit

          availableQuantity

          image {
            id
            path
            extension
          }

          deliveryOptions {
            edges {
              node {
                id
                type
              }
            }
          }
        }
      }
    }
  }
`

export const GRANTED_WEB_SECTION = gql`
  query GrantedWebSection($name: String!) {
    grantedWebSection(name: $name) {
      id
      name
      type
      settings
    }
  }
`

export const GRANTED_SEARCH = gql`
  query GrantedSearch($query: String!, $types: [String!]!, $partnerSlug: String) {
    grantedSearch(query: $query, types: $types, partnerSlug: $partnerSlug) {
      stars {
        slug
        imagePath
        fullName
      }
      venues {
        slug
        name
        imagePath
      }
      events {
        slug
        title
        eventStartDateLocal
        city
        state
      }
      tours {
        title
        slug
        imagePath
      }
    }
  }
`
